<template>
    <div class="page">
      <Header/>
      <MatchInfo />
      <VolleyBallHome />
      <Footer/>
    </div>
  </template>
  
<script>
import VolleyBallHome from '@comm/components/match/volleyball/VolleyBallHome';
import MatchInfo from '@comm/components/MatchInfo.vue'
import Header from '@district/components/common/MatchHeader.vue'
import Footer from '@district/components/common/Footer'
export default {
  name: 'VolleyBall',
  components: {
    Header,
    Footer,
    MatchInfo,
    VolleyBallHome
  },
  data () {
    return {
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  mounted () {
  },
  methods: {
  }
}
</script>
  <style lang="scss" scoped>
  .page {
    width: 100%;
  }
  </style>
  


// WEBPACK FOOTER //
// src/district/views/project/components/VolleyBall.vue